'use client';

import { useEffect, useRef } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';
import toast from 'react-hot-toast';

const MESSAGES: Record<string, string> = {
  'room-not-found': 'Meeting not found. Ask your host for a fresh link.',
};

export function RoomErrorToast() {
  const params = useSearchParams();
  const router = useRouter();
  const shown = useRef<string | null>(null);

  useEffect(() => {
    const error = params.get('error');
    if (!error || shown.current === error) return;
    const msg = MESSAGES[error] ?? 'Something went wrong.';
    toast.error(msg);
    shown.current = error;
    router.replace('/');
  }, [params, router]);

  return null;
}
